import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Avatar, Box, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import AnchorPopper from "../../../../../../components/forms/AnchorPopper";
import {
  StyledTextField,
  getTextFieldInputProps,
  textFieldLabelProps,
} from "../../../../../../components/forms/styles/formFieldStyles";

const JiraAssignee = ({ options, showOptions }) => {
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext();

  const hasError = !!touched.assignee && !!errors.assignee;
  const errorMessage =
    hasError && typeof errors.assignee === "string" ? errors.assignee : "";

  const assigneeLabel = <Typography variant="caption">Assignee</Typography>;

  return (
    <Autocomplete
      options={options || []}
      disabled={!showOptions}
      getOptionLabel={(option) => option.displayName || option}
      value={values.assignee}
      onChange={(_, newValue) => setFieldValue("assignee", newValue)}
      popupIcon={<ExpandMoreIcon />}
      PopperComponent={AnchorPopper}
      renderOption={(props, option) => (
        <Box
          component="li"
          sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}
          {...props}
        >
          <Avatar
            src={option.avatarUrls?.["16x16"]}
            alt={option.displayName}
            sx={{ width: 16, height: 16 }}
          >
            <Typography variant="caption">
              {option.displayName?.charAt(0)}
            </Typography>
          </Avatar>
          <Typography variant="caption">{option.displayName}</Typography>
        </Box>
      )}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          margin="dense"
          label={assigneeLabel}
          fullWidth
          required
          error={hasError}
          helperText={errorMessage}
          onBlur={handleBlur}
          InputProps={{
            ...getTextFieldInputProps(params.InputProps),
            startAdornment: values.assignee && (
              <Box
                component="li"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  ml: 0.5,
                }}
              >
                <Avatar
                  src={values.assignee?.avatarUrls?.["16x16"]}
                  alt={values.assignee.displayName}
                  sx={{ width: 16, height: 16, mr: 1 }}
                >
                  <Typography variant="caption">
                    {values.assignee.displayName?.charAt(0)}
                  </Typography>
                </Avatar>
              </Box>
            ),
          }}
          InputLabelProps={textFieldLabelProps(params.InputLabelProps)}
        />
      )}
    />
  );
};
export default JiraAssignee;
